import React, { useState, useEffect, useRef } from 'react';
import { Button, Image, Input, InputNumber, Form, message, Modal, Upload, Select, Tooltip, Table, Progress,Typography } from 'antd';
import { WarningOutlined, ZoomInOutlined, ExclamationCircleOutlined, LoadingOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';


import * as CONST from '../../common/const';
import * as REQUEST from "../../common/request";
import * as Utils from "../../common/utils";

import Page from '../../components/page';
import UploadPictureList from '../../components/uploadPictureList';
import './index.less';

const PageModel = props => {
  
  return (
    <Page {...{
      ...props,
      breadcrumbs: [{ label: '首页' }, { label: '游记攻略' }],
      title: '游记攻略'
    }}>
      <section className="travel-container" style={{ minHeight: window.innerHeight }}>
      
      </section>
    </Page>
  );
};

export default PageModel;
